export default __webpack_public_path__ + "static/media/UA.f9cbc20b.svg";